// React 19 compatibility polyfill for legacy ref access patterns

// This polyfill ensures compatibility with libraries that try to access element.ref
// which was removed in React 19

(function () {
  "use strict";

  // Only apply polyfill if we're in a React 19+ environment
  if (
    typeof React !== "undefined" &&
    React.version &&
    parseInt(React.version.split(".")[0]) >= 19
  ) {
    // Store original createElement and cloneElement
    const originalCreateElement = React.createElement;
    const originalCloneElement = React.cloneElement;

    // Enhanced createElement that handles ref properly
    React.createElement = function (type, props, ...children) {
      const element = originalCreateElement.call(this, type, props, ...children);

      // Add ref property accessor for compatibility
      if (element && typeof element === "object" && props && props.ref) {
        Object.defineProperty(element, "ref", {
          get: function () {
            return this.props.ref;
          },
          set: function (value) {
            if (this.props) {
              this.props.ref = value;
            }
          },
          configurable: true,
          enumerable: false,
        });
      }

      return element;
    };

    // Enhanced cloneElement that handles ref properly
    React.cloneElement = function (element, props, ...children) {
      const clonedElement = originalCloneElement.call(this, element, props, ...children);

      // Ensure ref accessibility on cloned elements
      if (clonedElement && typeof clonedElement === "object") {
        const refValue = (props && props.ref) || (element && element.props && element.props.ref);

        if (refValue) {
          Object.defineProperty(clonedElement, "ref", {
            get: function () {
              return this.props.ref;
            },
            set: function (value) {
              if (this.props) {
                this.props.ref = value;
              }
            },
            configurable: true,
            enumerable: false,
          });
        }
      }

      return clonedElement;
    };

    console.log("✓ React 19 ref compatibility polyfill loaded");
  }
})();
